import type { FlowEdge, FlowNode } from '@lighthouse/shared'

/**
 * 暂时只有 action 和 condition 节点可以被删除
 * @param node
 * @param nodes
 * @param edges
 * @returns
 */

export const deleteNode = (id: string, nodes: FlowNode[], edges: FlowEdge[]) => {
    const newNodes = nodes.filter(({ id: nId }) => nId !== id)
    const newEdges = edges.filter(({ source, target }) => source !== id && target !== id)

    return {
        nodes: newNodes,
        edges: newEdges
    }
}
